import { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthContext from "../modules/Core/store/auth-context";

/** Option 2 — redirige vers login si l'utilisateur n'est pas connecté. */
export function useRequireAuth() {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = !!authCtx.isLoggedIn;

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login", {
        replace: true,
        state: { returnTo: location.pathname + location.search },
      });
    }
  }, [isLoggedIn, navigate, location.pathname, location.search]);

  return isLoggedIn;
}
